/**
 * Cards Filter Dropdown Handler
 *
 * Manages the mobile dropdown functionality for the Money Goals navigation.
 * On mobile, the cards filter list acts as a dropdown menu with the active
 * card shown in a trigger button and other cards shown in a dropdown list.
 */

export function initCardsFilterDropdown() {
	const dropdown = document.querySelector( '.cards-filter-dropdown' );

	if ( dropdown ) {
		const trigger = dropdown.querySelector( '.cards-filter-dropdown-trigger' );
		const list = dropdown.querySelector( '.cards-filter-list' );
		const cards = list?.querySelectorAll( '.cards-filter-card' );

		if ( trigger && list && cards ) {
			// Toggle the legacy card dropdown when it exists on older authored content.
			trigger.addEventListener( 'click', function( e ) {
				e.preventDefault();
				list.classList.toggle( 'is-open' );
				trigger.setAttribute( 'aria-expanded', list.classList.contains( 'is-open' ) ? 'true' : 'false' );
			} );

			// Close the legacy dropdown after navigation begins so keyboard users get
			// the same collapsed state if navigation is cancelled or intercepted.
			cards.forEach( card => {
				card.addEventListener( 'click', function() {
					list.classList.remove( 'is-open' );
					trigger.setAttribute( 'aria-expanded', 'false' );
				} );
			} );

			// Close the dropdown when focus moves to an unrelated page area.
			document.addEventListener( 'click', function( e ) {
				if ( ! dropdown.contains( e.target ) ) {
					list.classList.remove( 'is-open' );
					trigger.setAttribute( 'aria-expanded', 'false' );
				}
			} );

			// Preserve button-like keyboard behavior for the custom trigger.
			trigger.addEventListener( 'keydown', function( e ) {
				if ( e.key === 'Enter' || e.key === ' ' ) {
					e.preventDefault();
					trigger.click();
				}
			} );

			// Let Escape return focus to the control that opened the dropdown.
			list.addEventListener( 'keydown', function( e ) {
				if ( e.key === 'Escape' ) {
					list.classList.remove( 'is-open' );
					trigger.setAttribute( 'aria-expanded', 'false' );
					trigger.focus();
				}
			} );
		}
	}

	// The coded Money Goals hero and the backwards-compatible selector shortcode
	// both store the destination URL as the option value. That keeps navigation
	// independent from term IDs and follows the same filtered public URLs used
	// everywhere else on the Money Goals experience.
	document.querySelectorAll( '[data-money-goal-selector]' ).forEach( ( selector ) => {
		selector.addEventListener( 'change', function() {
			if ( selector.value ) {
				window.location.assign( selector.value );
			}
		} );
	} );
}
